export var HideCssClass;
(function (HideCssClass) {
    HideCssClass["Base"] = "iress-hide";
    HideCssClass["VisuallyHidden"] = "iress-sr-only";
    HideCssClass["TotallyHidden"] = "iress-hidden";
})(HideCssClass || (HideCssClass = {}));
//# sourceMappingURL=hide.types.js.map